import { useSubmitBankAccountConnectionTooLongMutation } from '@twisto/api-graphql'
import {
  FlowFormSubmitInfoView,
  useSubmittingWrapper,
} from '@twisto/flow-views/components'
import { BigClockIcon } from '@twisto/icons'

import { useFlow } from '../../flow/flow.context'

export const IncomeVerificationBankAccountConnectionTooLongStep = () => {
  const { flow, sessionId } =
    useFlow<'IncomeVerificationBankAccountConnectionTooLongStep'>()
  const [submitBankAccountConnectionTooLong] =
    useSubmitBankAccountConnectionTooLongMutation()
  const submittingWrapper = useSubmittingWrapper()

  const handleSubmitField = () =>
    submittingWrapper(
      submitBankAccountConnectionTooLong({
        variables: {
          auth: {
            sessionId,
          },
        },
      })
    )

  const { heading, textParagraphs, buttonText } = flow.currentStep

  return (
    <FlowFormSubmitInfoView
      buttonText={buttonText}
      icon={<BigClockIcon color="warning" height="100%" width="100%" />}
      subtitle={textParagraphs}
      title={heading}
      onSubmit={handleSubmitField}
    />
  )
}
